export default class Device {
    constructor() {
        this.onBackButton = null;
        document.addEventListener("deviceready", this.onDeviceReady.bind(this), false);
    }
    onDeviceReady() {
        document.addEventListener("backbutton", this.backButton.bind(this), false);
        if (typeof AndroidFullScreen !== "undefined") {
            AndroidFullScreen.immersiveMode();
        }
    }
    backButton(e) {
        if (this.onBackButton) {
            e.preventDefault();
            this.onBackButton();
        }
    }
    exitApp() {
        if (navigator.app) {
            navigator.app.exitApp();
        } else if (navigator.device) {
            navigator.device.exitApp();
        } else {
            window.close();
        }
    }
    getOS() {
        let ua = navigator.userAgent;
        let isCordova = typeof cordova != "undefined";

        //var url = window && window.location && window.location.href && window.location.href || "";

        if (/(Windows Phone.*MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windowsPhone";
        }
        if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windows";
        }

        let isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);
        if (/(android)/i.test(navigator.userAgent) && isKindle) {
            return "amazon";
        }
        if (/(android)/i.test(navigator.userAgent) && !isKindle) {
            return "android";
        }
        if ((/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel')) {
            return "ios";
        }
        //pwa + edg = Edge
        const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
        if (isInStandaloneMode && /(Edg)/i.test(navigator.userAgent)) {
            return "windows";
        }
        return "web";
    }
    getBrowser() {
        var ua = navigator.userAgent;
        return ua;
    }
    getPlatform() {
        let isOnFacebook = (typeof FBInstant !== "undefined");
        if (isOnFacebook) return "FBInstant";
        let isCordova = (typeof cordova !== "undefined");
        if (isCordova) return "Cordova";
        return "web";
    }
}
